<template>
  <div class="folder-form-container relative w-full h-full">
    <div v-if='!isLoading'>
      <button
        class="close-folder"
        @click="activeDialog(true)"
        data-vs-button="activeDialog"
      >
        <zt-icon name="times" />
      </button>
      <div class="content-wrapper px-32 py-16" :style="styles">
        <sub-folder-name />
        <sub-folder-document-type v-if="isEformsAvailable && isSignatureRequired" />
        <sub-folder-document-salary-receipt v-if="!isDigitalDocument && isSignatureRequired" />
        <sub-folder-document-type-xml v-if="loadPDFXML && isSignatureRequired" />
        <sub-folder-document-identificator
          v-if='!isDigitalDocument' :list="parsers" />
        <sub-folder-document-name-email v-if='!isDigitalDocument' />
        <sub-folder-document-generic v-if="isGenericDocumentAvailable" />
        <sub-folder-load-documents
          v-if='isEformsAvailable && !isDigitalDocument && !isPDFXML && !isGenericDocument'
          :templateLoadDocument="templateLoad"
        />
        <sub-folder-document-ai v-if="isIAConfigAvailable" />
        <sub-folder-document-configuration v-if="!isDigitalDocument && isSignatureRequired" />
      </div>
      <div class="footer flex justify-between items-center px-10 h-24">
        <div class="flex justify-start">
          <zt-tooltip
            v-if="isUpdate"
            :active="!isDeleteAvailable"
            :text="$t('message.abm.folders.tooltipSubFolder')"
            position="right"
            title=""
          >
            <zt-button
              text
              class="button-cancel button-delete"
              data-vs-button="activeDeleteDialog"
              :class="{
              'text-zt-danger': isUpdate && isDeleteAvailable,
              'cursor-pointer': isUpdate && isDeleteAvailable,
              'cursor-not-allowed': !isDeleteAvailable
            }"
              @click="activeDeleteDialog(true)"
            >
              <span>{{$t('message.abm.folders.deleteSubFolder') }}</span>
            </zt-button>
          </zt-tooltip>
        </div>
        <div class="justify-end">
          <zt-button
            text
            class="button-cancel mr-4"
            @click="activeDialog(true)"
            data-vs-button="activeDialog"
          >
            {{$t('message.abm.folders.cancelSubFolder') }}
          </zt-button>
          <zt-button
            loaderTxt="Cargando..."
            :disabled="!saveAvailable"
            :loader="loadingButton"
            :class="{
              'text-zt-dark-b6': !saveAvailable,
              'text-zt-dark-200': !saveAvailable
            }"
            @click="saveSubFolder"
            data-vs-button="saveSubFolder"
          >{{$t('message.abm.folders.saveSubFolder') }}</zt-button>
        </div>
      </div>
      <cancel-sub-folder-dialog
        ref="modal"
        :active="cancel"
        :with-sub-folder=true
        :is-leave="isLeave"
      />
      <error-dialog
        :message="messageError"
        :description="messageErrorDescription"
        :active="isActiveErrorDialog"
        :returnToBack="isReturnToBack"
      />
      <delete-sub-folder-dialog
        v-if="isUpdate && isDeleteAvailable"
        :sub-folder-name="stateFolder.subFolderParams.name"
        :folder-id="stateFolder.subFolderParams.folderId"
        :sub-folder-id="stateFolder.subFolderParams.id"
        :active="isActiveDeleteDialog"
      />
    </div>
    <div class="w-full h-full" v-else>
      <vue-element-loading
        :active="isLoading"
        spinner="spinner"
        duration="1.5"
        color="#4f4f4f"
        size="50"
      />
    </div>
  </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'
import SubFolderName from '@/modules/Folders/components/settings/subfolder/SubFolderName'
import SubFolderDocumentType from '@/modules/Folders/components/settings/subfolder/SubFolderDocumentType'
import SubFolderDocumentTypeXml from '@/modules/Folders/components/settings/subfolder/SubFolderDocumentTypeXML'
import SubFolderDocumentNameEmail from '@/modules/Folders/components/settings/subfolder/SubFolderDocumentNameEmail'
import SubFolderDocumentIdentificator from '@/modules/Folders/components/settings/subfolder/SubFolderDocumentIdentificator'
import SubFolderDocumentAi from '@/modules/Folders/components/settings/subfolder/SubFolderDocumentAi'
import useFolderState from '@/modules/Folders/hooks/useFolderState'
import CancelSubFolderDialog from '@/modules/Folders/components/modals/CancelSubFolderDialog'
import DeleteSubFolderDialog from '@/modules/Folders/components/modals/DeleteSubFolderDialog'
import ErrorDialog from '@/modules/Folders/components/modals/ErrorDialog'
import { isEqual, clone, orderBy, isEmpty } from 'lodash'
import Company from '../../../apiClient/Company'
import Folders from '../../../apiClient/Folders'
import Signature from '../../../apiClient/Signature'
import SubFolderLoadDocuments from "@/modules/Folders/components/settings/subfolder/SubFolderLoadDocuments";
import SubFolderDocumentConfiguration from "@/modules/Folders/components/settings/subfolder/SubFolderDocumentConfiguration";
import { mapGetters } from 'vuex';
import SubFolderDocumentGeneric from "@/modules/Folders/components/settings/subfolder/SubFolderDocumentGeneric";
import useModalState from '@/modules/Folders/hooks/useModalState'
const { state: modalState, setModalState, setModalStateProperty, resetModalState } = useModalState()
import SubFolderDocumentSalaryReceipt
  from '@/modules/Folders/components/settings/subfolder/SubFolderDocumentSalaryReceipt.vue'
const {
  state: stateFolder,
  setSubFolderParams,
  setSubFolderSignatureParams,
  setCompanyLogo,
  resetSubFolderParams,
  setPreviewConfiguration,
  resetError,
  setError,
  setDocumentConfiguration,
  setSignatureEmployer,
  setSignatureEmployee,
  setSignatureDefault,
  resetPreviewConfiguration,
  resetDocumentConfiguration
} = useFolderState()


export default {
  name: 'SubFoldersABM',
  components: {
    SubFolderDocumentGeneric,
    VueElementLoading,
    SubFolderLoadDocuments,
    SubFolderDocumentConfiguration,
    SubFolderName,
    SubFolderDocumentType,
    SubFolderDocumentTypeXml,
    SubFolderDocumentIdentificator,
    SubFolderDocumentNameEmail,
    SubFolderDocumentAi,
    CancelSubFolderDialog,
    DeleteSubFolderDialog,
    ErrorDialog,
    SubFolderDocumentSalaryReceipt
  },
  provide() {
    return {
      activeDialog: this.activeDialog,
      activeDeleteDialog: this.activeDeleteDialog,
      activeErrorDialog: this.activeErrorDialog,
      stateFolder,
      setSubFolderParams,
      setSubFolderSignatureParams,
      resetSubFolderParams,
      resetError,
      setError,
      setPreviewConfiguration,
      setDocumentConfiguration,
      setSignatureEmployer,
      setSignatureEmployee,
      setSignatureDefault,
      resetPreviewConfiguration,
      resetDocumentConfiguration,

      modalState,
      resetModalState,
      setModalState,
      setModalStateProperty
    }
  },
  data() {
    return {
      isMounted: false,
      isLoading: false,
      isLeave: false,
      isMX: false,
      isSignatureRequired: false,
      isFolderEphemeral: false,
      saveAvailable: false,
      loadingButton: false,
      cancel: false,
      stateFolder: stateFolder,
      cache: {},
      isActiveErrorDialog: false,
      isActiveDeleteDialog: false,
      isReturnToBack: false,
      messageError: '',
      messageErrorDescription: '',
      isDeleteAvailable: false,
      parsers: [],
      templateLoad: [],
      styles: {},
      appliedConfig: []
    }
  },
  computed: {
    ...mapGetters(['isActionAllowed', 'getUser']),
    errorText() {
      if (this.errors.first('nb-subfolder')) {
        return this.errors.first('nb-subfolder')
      }
      return ''
    },
    isPDFXML() {
      return this.loadPDFXML && this.stateFolder.subFolderParams.documentType === 'pdfxml'
    },
    loadPDFXML() {
      return this.isMX && !this.isDigitalDocument
    },
    isUpdate() {
      return this.stateFolder.subFolderParams.isUpdate
    },
    isDigitalDocument() {
      return this.stateFolder.subFolderParams.isDigitalDocument
    },
    isEformsAvailable() {
      return this.isActionAllowed(62)
    },
    rotationValue() {
      return stateFolder.subFolderParams.documentConfiguration.rotation === 360
          ? 0
          : stateFolder.subFolderParams.documentConfiguration.rotation
    },
    isGenericDocument() {
      return this.stateFolder.subFolderParams.isGenericDocument
    },
    isGenericDocumentAvailable() {
      return this.isActionAllowed(302) || this.isActionAllowed(58)
    },
    isIAConfigAvailable() {
      return !this.isFolderEphemeral && !this.isDigitalDocument && this.isActionAllowed(303)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.saveAvailable) {
      this.isLeave = true
      this.activeDialog(true)
      this.$nextTick(() => {
        this.$refs.modal.$once('confirm-leave', async bvEvt => {
          if (bvEvt) {
            await resetSubFolderParams()
            next()
          }
        })
      })
      return
    }
    next()
  },
  async created() {
    window.scrollTo(0, 0)
    this.folderApi = new Folders()
    this.signatureInstance = new Signature()
    this.isMX = this.getUser.pais === 'MX'
    await setSubFolderParams({ folderId: this.$route.params.id })
    const id = this.$route.params.subfolder
    if (id && this.$route.name === 'subFolderUpdate') {
      setSubFolderParams({ isUpdate: true })
      setSignatureDefault(false)
      this.id = parseInt(id)
      await this.getConfigurationSubFolder()
      try {
        await this.getConfigurationSubFolderSignature()
      } catch (e) {}
    }
    await this.getConfigurationFolder()
    await this.getInformationCompany()
    await this.getApplicationParser()
    await this.getTemplateLoadDocument()
    this.cache = clone(this.stateFolder.subFolderParams)
  },
  mounted() {
    this.isMounted = true
    window.addEventListener('resize', this.handleStyles)
    this.handleStyles()
  },
  watch: {
    stateFolder: {
      handler() {
        const changed = !isEqual(this.cache, this.stateFolder.subFolderParams)
        if (
          stateFolder.subFolderParams.emailNameOverride &&
          stateFolder.subFolderParams.emailName.length
        ) {
          this.saveAvailable = !!stateFolder.subFolderParams.name.length
            && changed
        } else {
          this.saveAvailable = stateFolder.subFolderParams.name.length
            && !stateFolder.subFolderParams.emailNameOverride && changed
        }
      },
      deep: true
    }
  },
  methods: {
    async activeDialog(active) {
      if (!this.saveAvailable) {
        await resetSubFolderParams()
        await this.$router.push({
          id: this.$route.params.id,
          name: 'subfolder',
        })
        return
      }
      if (!active) this.isLeave = false
      this.cancel = active
    },
    activeErrorDialog(active) {
      this.isActiveErrorDialog = active
    },
    activeDeleteDialog(active) {
      if (!this.isDeleteAvailable) {
        return
      }
      this.isActiveDeleteDialog = active
    },
    async getConfigurationFolder() {
      try {
        const folderId = this.stateFolder.subFolderParams.folderId
        const {
          data: { data }
        } = await this.folderApi.getConfigurationFolder(folderId)
        this.isSignatureRequired = data.firmable
        this.isFolderEphemeral = data.efimero
      } catch (e) {
        throw e.response
      }
    },
    async getConfigurationSubFolder() {
      this.isLoading = true
      try {
        const {
          data: { data }
        } = await this.folderApi.getConfigurationSubFolder(this.id)
        if(!isEmpty(data.rotation) && parseInt(data.rotation) !== 0) {
          setDocumentConfiguration({ rotationApplied: true })
          this.appliedConfig.push({
            id: 'rotation',
            name: 'Rotacion',
            icon: 'circle-arrow-outline'
          })
        }
        if(data.crop) {
          setDocumentConfiguration({ croppedApplied: true })
          this.appliedConfig.push({
            id: 'cutPdf',
            name: 'Corte',
            icon: 'crop-outline'
          })
        }
        setDocumentConfiguration({
          appliedConfig: this.appliedConfig,
          crop: data.crop ? JSON.parse(data.crop) : '',
          rotation: data.rotation ? parseInt(data.rotation) : 0
        })
        const params = {
          docSinId: data.doc_sin_id,
          deleteFolder: data.deleteSubFolder,
          id: data.id,
          isDigitalDocument: data.tipo === 'eform',
          documentType: data.tipo,
          emailName: data.texto_mail || '',
          emailNameOverride: !isEmpty(data.texto_mail),
          name: data.nombre,
          parser: data.parserscript || '',
          templateId: data.id_template,
          isLoadDocument: !(!isEmpty(data.id_template) || data.id_template === 0),
          visible: data.visible,
          isAiDocument: data.sendia === 1,
          isSalaryReceipt: data.receiptType === 1
        }
        await setSubFolderParams(params)
        this.isDeleteAvailable = this.stateFolder.subFolderParams.deleteFolder
        this.cache = clone(this.stateFolder.subFolderParams)
        this.isLoading = false
      } catch (e) {
        const { code } = e.response.data.codes[0]
        if(code === '10049') {
          this.messageError = this.$t(`message.abm.folders.errors.${code}`)
          this.activeErrorDialog(true)
          this.isReturnToBack = true
        }
        this.isLoading = false
      }
    },
    async getConfigurationSubFolderSignature() {
      this.isLoading = true
      try {
        const {
          data: { data }
        } = await this.folderApi.getConfigurationSubFolderSignature(this.id)
        setSignatureEmployee(data.position_signature.employee)
        setSignatureEmployer(data.position_signature.employer)
        const properties = {
          orientation: data.orientation,
          paper: data.paper
        }
        setSignatureEmployee(properties)
        if (!isEmpty(data.position_signature.employer)) {
          setSignatureEmployer(properties)
        }
        if(data.position_signature.employee) {
          this.appliedConfig.push({
            id: 'signDef',
            name: 'Firma colaborador',
            icon: 'sign-pencil-outline'
          })
        }
        if(data.position_signature.employer) {
          this.appliedConfig.push({
            id: 'signEmp',
            name: 'Firma empleador',
            icon: 'sign-pencil-outline'
          })
        }
        setDocumentConfiguration(properties)
        const file = await this.signatureInstance.getCustomFile(this.id).catch(e => {})
        if(file) {
          const byteString = window.atob(file.data);
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const int8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
          }
          let tempFile = new File([int8Array], `${data.name}`, { type: 'application/pdf' })
          setDocumentConfiguration({
            file: tempFile,
            fileBase64: file.data
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        throw e.response
      }
    },
    async getInformationCompany() {
      const company = new Company()
      try {
        const uuid = this.$store.getters.getUser.id
        const response = await company.client.getImage(uuid)
        const companyLogo = `data:image/*;base64, ${response}`
        setCompanyLogo(companyLogo)
      } catch (e) {
        console.error(e)
      }
    },
    async saveSubFolder() {
      this.messageError = ''
      this.messageErrorDescription = ''
      try {
        this.loadingButton = true
        const subFolder = {
          alias: stateFolder.subFolderParams.emailName,
          idCarpeta: stateFolder.subFolderParams.folderId,
          idTemplate: stateFolder.subFolderParams.templateId,
          nombre: stateFolder.subFolderParams.name,
          parser: stateFolder.subFolderParams.parser || '',
          tipo: stateFolder.subFolderParams.documentType,
          visible: stateFolder.subFolderParams.visible ? 1 : 0,
          sinCodigo: stateFolder.subFolderParams.docSinId ? 1 : 0,
          crop: stateFolder.subFolderParams.documentConfiguration.crop ? stateFolder.subFolderParams.documentConfiguration.crop : '',
          rotation: this.rotationValue,
          employee: stateFolder.subFolderParams.documentConfiguration.employeeSignature,
          employer: !isEmpty(stateFolder.subFolderParams.documentConfiguration.employerSignature) && stateFolder.subFolderParams.documentConfiguration.employerSignature.show ? stateFolder.subFolderParams.documentConfiguration.employerSignature : '',
          file: stateFolder.subFolderParams.documentConfiguration.file,
          sendIa: stateFolder.subFolderParams.isAiDocument ? 1 : 0,
          receiptType: stateFolder.subFolderParams.isSalaryReceipt ? 1 : 0
        }
        if (this.isUpdate) {
          delete subFolder['file']
          await this.folderApi.updateSubFolder({id: this.id, ...subFolder })
          if (
            stateFolder.subFolderParams.documentConfiguration.file
          ) {
            await this.folderApi.setNewPDFFile(this.id, {
              employee: stateFolder.subFolderParams.documentConfiguration.employeeSignature,
              employer: !isEmpty(stateFolder.subFolderParams.documentConfiguration.employerSignature) && stateFolder.subFolderParams.documentConfiguration.employerSignature.show ? stateFolder.subFolderParams.documentConfiguration.employerSignature : '',
              file: stateFolder.subFolderParams.documentConfiguration.file
            })
          }
        } else {
          await this.folderApi.createSubFolder(subFolder)
        }
        this.saveAvailable = false
        this.loadingButton = false
        const id = stateFolder.subFolderParams.folderId
        resetSubFolderParams()
        resetModalState()
        await this.$router.push({
          id,
          name: 'subfolder'
        })
      } catch (e) {
        if (e.response && e.response.status === 400) {
          let code = ''
          let message = ''
          let messageErrorDescription = ''
          if (e.response.data.codes && e.response.data.codes.length) {
            code = e.response.data.codes[0].code
            message = this.$t(`message.abm.folders.errors.${code}`)
          } else {
            const { data: { message: errMessage } } = e.response.data.results
            code = 'THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE'
            message = this.$t('message.abm.folders.errors.THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE', {
              docName: this.getDocName(errMessage)
            })
            messageErrorDescription = this.$t('message.abm.folders.errors.THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE_DESCRIPTION')
          }
          if (code !== '10036' && code !== '10028') {
            this.messageError = message
            this.messageErrorDescription = messageErrorDescription
            this.activeErrorDialog(true)
          }
          setError({ code, message })
        }
        this.loadingButton = false
      }
    },
    async getApplicationParser() {
      try {
        const { data: { data }} = await this.folderApi.getApplicationParser()
        this.parsers = data.map(item => {
          if (item.alias.toLowerCase() === 'nombre de archivo') {
            item.alias = this.$t('message.abm.folders.fileNameAlias')
            item['description'] = this.$t('message.abm.folders.fileNameDescription')
          } else {
            item.alias = this.$t('message.abm.folders.searchDocumentAlias')
            item['description'] = this.$t('message.abm.folders.searchDocumentDescription')
          }
          return item
        })
      } catch (e) {
        if(e.response.status === 400) {
          let code = '10049'
          this.messageError = this.$t(`message.abm.folders.errors.${code}`)
          this.activeErrorDialog(true)
          this.isReturnToBack = true
        }
      }
    },
    async getTemplateLoadDocument() {
      try {
        const { data: { data } } = await this.folderApi.getTemplateSubFolders()
        this.templateLoad = data.map(item => {
          let itemTmp = {}
          itemTmp['id'] = item.id
          itemTmp['min_files'] = item.json.min_files
          if(item.json.min_files === 1) {
            itemTmp['description'] = `${item.json.min_files} página es requerida y obligatoria`
            itemTmp['alias'] = `${item.json.min_files} página`
          } else {
            itemTmp['description'] = `${item.json.min_files} páginas son requeridas y obligatorias`
            itemTmp['alias'] = `${item.json.min_files} páginas`
          }
          return itemTmp
        })
        this.templateLoad = orderBy(this.templateLoad, ['min_files'], ['asc'])
      } catch (e) {

      }
    },
    handleStyles () {
      const div = document.querySelector('.folder-form-container')
      const bbox = div.getBoundingClientRect()
      this.styles = {
        'min-height': `calc(${bbox.height}px - 6rem)`
      }
    },
    getDocName(string) {
      const regExp = /subfolder(.*?)has/i
      const result = regExp.exec(string)
      return result ? result[1].trim() : ''
    }
  }
}
</script>
<style scoped lang="scss">
.folder-form-container {
  overflow-y: auto;
  .close-folder {
    font-size: 24px;
    line-height: 1;
    position: absolute;
    right: 2.5rem;
    top: 4.85rem;
  }
}
.folder-form-container::-webkit-scrollbar-track {
  background-color: #c4c4c4;
}
.folder-form-container::-webkit-scrollbar {
  width: 0.625rem;
}
.folder-form-container::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #888888;
}
.content-wrapper {
  min-height: calc(100% - 6rem);
}
.footer {
  background: #E5E5E5;
  border-top: 1px solid #C4C4C4;
  font-size: 1.125rem;
  .text-zt-dark-b6 {
    color: #B6B6B6!important;
  }
  ::v-deep {
    .button-cancel {
      color: #707070!important;
      background: transparent!important;
    }
    button.button-delete {
      padding: 0!important;
    }
    .button-cancel.text-zt-danger {
      color: #f16b6c!important;
      &:hover {
        span {
          border-bottom: solid 1px #f16b6c;
          line-height: 1;
        }
      }
    }
  }
}
</style>
